import { Injectable, inject } from '@angular/core'
import { ActivatedRoute, Params, Router } from '@angular/router'

@Injectable({
  providedIn: 'root',
})
export class TerminalRoutingService {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private router = inject(Router)
  private activatedRoute = inject(ActivatedRoute)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/
  public updateQueryParams(queryParams: Params): void {
    console.debug(`updating queryParams: ${JSON.stringify(queryParams)}`)
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams,
      queryParamsHandling: 'merge',
    })
  }

  public clearQueryParams(): void {
    this.router.navigate(['./'])
  }
}
